/** Brief 12, K3 - Hisobotlar. */
export const uzB12Reports = {
  "reports12.title": "Hisobotlar",
  "reports12.myTitle": "Mening hisobotim",
  "reports12.allBranches": "Barcha filiallar",
  "reports12.period": "Davr",
  "reports12.period.hafta": "Hafta",
  "reports12.period.oy": "Oy",
  "reports12.period.chorak": "Chorak",
  "reports12.quarterMeta": "{from}–{to}",
  "reports12.excel": "Excel",
  "reports12.excelDone": "{file} yuklab olindi",
  "reports12.excelFailed": "Excel faylni olib bo'lmadi. Qayta urinib ko'ring.",
  "reports12.tabs": "Hisobotlar bo'limlari",
  "reports12.more": "Boshqa hisobotlar",
  "reports12.currency": "Valyuta",
  "reports12.loading": "Hisobot tuzilmoqda…",
  "reports12.empty.title": "Hisobot uchun ma'lumot kam",
  "reports12.empty.message": "Hisobot kamida 7 kunlik bitim va murojaatlardan tuziladi.",
  "reports12.empty.action": "Bitimlarga",
  "reports12.error.title": "Hisobot yuklanmadi",
  "reports12.denied": "{role} roli bu bo'limni ko'rmaydi. Kerak bo'lsa, agentlik egasiga yozing.",
  "reports12.denied.home": "Bosh sahifaga",
  "reports12.kpiGroup": "Hisobot ko'rsatkichlari",
  "reports12.floor": "kamida {count} ta kerak",
  "reports12.late": "{count} kechikkan",
  "reports12.points": "p.p.",
  "reports12.previousPeriod": "o'tgan davrga",
  "reports12.mln": "{value} mln so'm",

  "reports12.kpi.revenue": "Daromad",
  "reports12.kpi.sales": "Sotuvlar",
  "reports12.kpi.average_check": "O'rtacha chek",
  "reports12.kpi.conversion": "Konversiya",
  "reports12.kpi.active_operators": "Faol operatorlar",
  "reports12.kpi.response": "O'rtacha javob",
  "reports12.kpi.firstResponse": "O'rtacha birinchi javob",
  "reports12.kpi.sla": "SLA bajarildi",
  "reports12.kpi.unanswered": "Javobsiz qoldi",
  "reports12.kpi.leads": "Murojaatlar",
  "reports12.kpi.telegram_share": "Telegram",
  "reports12.kpi.instagram_share": "Instagram",
  "reports12.kpi.best_source": "Eng yaxshi konversiya",
  "reports12.kpi.cash": "Tushum",
  "reports12.kpi.margin": "Marja",
  "reports12.kpi.margin_percent": "O'rtacha marja",
  "reports12.kpi.debts": "Mijozlar qarzi",

  "reports12.chart.sales": "Daromad",
  "reports12.chart.operators": "Yopilgan bitimlar",
  "reports12.chart.sources": "Murojaatlar",
  "reports12.chart.finance": "Marja",
  "reports12.chart.personal": "Sotuvlarim",
  "reports12.step.hafta": "kunlik",
  "reports12.step.oy": "5 kunlik",
  "reports12.step.chorak": "oylik",

  "reports12.table.branchOperators": "Filial va operatorlar",
  "reports12.table.operators": "Operatorlar bo'yicha",
  "reports12.table.destinations": "Yo'nalishlar bo'yicha",
  "reports12.table.sources": "Manbalar bo'yicha",
  "reports12.table.vendors": "Turoperatorlar bo'yicha marja",
  "reports12.table.deals": "Yopilgan bitimlar",
  "reports12.table.empty": "Bu davrda yozuv yo'q",
  "reports12.col.operator": "Operator",
  "reports12.col.branch": "Filial",
  "reports12.col.sales": "Sotuv",
  "reports12.col.conversion": "Konversiya",
  "reports12.col.response": "Javob",
  "reports12.col.sla": "SLA",
  "reports12.col.destination": "Yo'nalish",
  "reports12.col.revenue": "Daromad",
  "reports12.col.average": "O'rtacha chek",
  "reports12.col.source": "Manba",
  "reports12.col.leads": "Murojaat",
  "reports12.col.vendor": "Turoperator",
  "reports12.col.bookings": "Bronlar",
  "reports12.col.turnover": "Aylanma",
  "reports12.col.margin": "Marja",
  "reports12.col.marginPercent": "Marja, %",
  "reports12.col.deal": "Bitim",
  "reports12.col.client": "Mijoz",
  "reports12.col.amount": "Summa",
  "reports12.dealNumber": "№{id}",

  "reports12.loss.title": "Yo'qotish sabablari",
  "reports12.loss.meta": "Suhbat yopish va bitim yo'qotish sabablaridan · {count} ta",
  "reports12.count": "{count} ta",

  "reports12.portrait.line": "{period} · {leads} lid, {booked} bron",
  "reports12.portrait.ai": "Xulosa",
  "reports12.portrait.who.hafta": "O'tgan hafta asosiy mijoz",
  "reports12.portrait.who.oy": "O'tgan oy asosiy mijoz",
  "reports12.portrait.who.chorak": "O'tgan chorak asosiy mijoz",
  "reports12.portrait.smallBase": "Ma'lumot kam, xulosa taxminiy.",
  "reports12.portrait.budget": "Byudjet taqsimoti",
  "reports12.portrait.otherBudgets": "Byudjeti boshqa valyutada: {count} ta, hisobga olinmagan",
  "reports12.portrait.destinations": "Top yo'nalishlar",
  "reports12.portrait.party": "Kim bilan sayohat",
  "reports12.portrait.channels": "Kanal",
  "reports12.portrait.months": "Sayohat oyi",
  "reports12.portrait.monthsMeta": "qaysi oyga bron qilishmoqda",
  "reports12.portrait.noData": "Ma'lumot yetarli emas",
  "reports12.portrait.monthsHint": "Sayohat oyi uchun kamida 30 kunlik bron kerak. «Oy» davrini tanlang.",

  "reports12.band.under_1000": "$1 000 gacha",
  "reports12.band.to_1500": "$1 000–1 500",
  "reports12.band.to_2500": "$1 500–2 500",
  "reports12.band.to_4000": "$2 500–4 000",
  "reports12.band.over_4000": "$4 000 dan yuqori",
  "reports12.party.family": "Oila, bolalar bilan",
  "reports12.party.couple": "Juftlik",
  "reports12.party.friends": "Do'stlar",
  "reports12.party.solo": "Yolg'iz",
  "reports12.party.corporate": "Korporativ",

  "reports12.day.0": "Du",
  "reports12.day.1": "Se",
  "reports12.day.2": "Ch",
  "reports12.day.3": "Pa",
  "reports12.day.4": "Ju",
  "reports12.day.5": "Sh",
  "reports12.day.6": "Ya",
  "reports12.month.1": "Yan",
  "reports12.month.2": "Fev",
  "reports12.month.3": "Mar",
  "reports12.month.4": "Apr",
  "reports12.month.5": "May",
  "reports12.month.6": "Iyn",
  "reports12.month.7": "Iyl",
  "reports12.month.8": "Avg",
  "reports12.month.9": "Sen",
  "reports12.month.10": "Okt",
  "reports12.month.11": "Noy",
  "reports12.month.12": "Dek",
  "reports12.monthName.1": "Yanvar",
  "reports12.monthName.2": "Fevral",
  "reports12.monthName.3": "Mart",
  "reports12.monthName.4": "Aprel",
  "reports12.monthName.5": "May",
  "reports12.monthName.6": "Iyun",
  "reports12.monthName.7": "Iyul",
  "reports12.monthName.8": "Avgust",
  "reports12.monthName.9": "Sentabr",
  "reports12.monthName.10": "Oktyabr",
  "reports12.monthName.11": "Noyabr",
  "reports12.monthName.12": "Dekabr",

  "reports12.tab.sales": "Sotuv",
  "reports12.tab.operators": "Operatorlar",
  "reports12.tab.sources": "Manbalar",
  "reports12.tab.finance": "Moliya",
  "reports12.tab.portrait": "Mijozlar portreti",
  "reports12.tab.dynamics": "Kirim va chiqim",
  "reports12.tab.operatorsDetail": "Operatorlar: pul va hissa",
  "reports12.tab.leads": "Lidlar",
  "reports12.tab.funnel": "Voronka",
  "reports12.tab.channels": "Lid manbalari",
  "reports12.tab.responses": "Javob tezligi",
  "reports12.tab.margin": "Marja",
  "reports12.tab.debtors": "Qarzdorlar",
  "reports12.tab.ai": "AI",
  "reports12.tab.custdev": "Oylik CustDev",
  "reports12.tab.branches": "Filiallar",
} as const;
